module.exports = __webpack_public_path__ + "static/media/GLORY_6721.a7d471e1.jpg";